import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class BlogTag extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/blog/tag'
    super(store, path)
  }
}
